import React, { Component } from 'react';
import ThemedButton from '../CommonComponents/ThemedButtons';

type Props = {
  userName: string;
  RemoveUser: Function;
  onClose: Function;
  origin: string;
};

type State = {};

export default class DeleteUserModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
  }
  setInitialState(): State {
    return {};
  }
  render() {
    return (
      <div>
        <div style={{ fontSize: '14px' }}>
          Please confirm, remove {this.props.userName} from the role of{' '}
          {this.props.origin === 'Admin' ? 'Hybrid Chat Admin/ Analyst' : 'an agent'} for
          this bot?
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
          <div style={{ marginRight: '10px' }}>
            <ThemedButton
              theme='3'
              title='Cancel'
              onClick={() => {
                this.props.onClose();
              }}
            />
          </div>
          <ThemedButton
            theme='0'
            title='Remove'
            onClick={() => {
              this.props.RemoveUser();
            }}
          />
        </div>
      </div>
    );
  }
}
